// extracted by mini-css-extract-plugin
export default {"cardContent":"cardContent__G41t-","cardBody":"cardBody"};